/**
 * emoji 表情编码
 */
const REGEXP_EMOJI = /\p{Emoji_Modifier_Base}\p{Emoji_Modifier}?|\p{Emoji_Presentation}|\p{Emoji}\uFE0F/gu;

/**
 * 地图插件,数据过滤完整匹配规则
 * 匹配`#回复内容:：` 到 `#地点列表:：` 之间的内容
 */
const REGEXP_MAP_COMPLETE_CONTENT =  /(#\s*回复内容:?：?|\*{0,2}回复内容\*{0,2}:?：?)(.*?)(#\s*地点列表:?：?|\*{0,2}地点列表\*{0,2}:?：?)/s;

/**
 * 地图插件,数据过滤起点匹配规则
 * 匹配`#回复内容:：` 之后的内容 $2
 */
const REGEXP_MAP_UNLESS_CONTENT_HEAD = /(#\s*回复内容:?：?|\*{0,2}回复内容\*{0,2}:?：?)(.*)/s;

/**
 * 地图插件,数据过滤结尾匹配规则
 * 匹配·`#地点列表:：` 之前的内容 $1
 */
const REGEXP_MAP_UNLESS_CONTENT_TAIL =  /^(.*?)(?=#\s*地点列表:?：?|\*{0,2}地点列表\*{0,2}:?：?)/s;
/**
 * 地图插件，去除开头内容，避免丢给打字机
 */
const REGEXP_MAP_HEAD_REPLACER = /^(#\s*(回复|内容|:|：){1,5}\s*)/;

/**
 * 地图插件，去除结尾内容，避免丢给打字机
 */
const REGEXP_MAP_TAIL_REPLACER = /(#\s*(地点|列表|:|：){1,5}\s*)$/;

/**
 * 标点符号
 */
const REGEXP_PUNCTUATION = /\p{Punctuation}/gu;

/**
 * 代码
 */
const REGEXP_CODE = /```.+\n((.|\n)+)\n```/;

/**
 * 代码 - 图表
 */
const REGEXP_CHART = /```chart.+\n((.|\n)+)\n```/;

/**
 * 一言主站 图片
 */
const REGEXP_IMG = /<img>(.*?)<\/img>/;

/**
 * 一言主站 图片
 */
const REGEXP_IMG_URL = /<url>(.*?)<\/url>/;

/**
 * 一言主站 文件
 */
const REGEXP_FILE = /<file>(.*?)<\/file>/;

/**
 * 一言主站 图表
 */
const REGEXP_YIYAN_CHART = /```echarts-option\s*\n((.|\n)+)\n```/;

/**
 * 表格
 */
const REGEXP_TABLE = /(\|\s*[^\|]*\s*\|\n\|\s*[:-]{2,}\s*\|)/;

/**
 * html 标签
 */
const REGEXP_HTML = /<([\w-]+)[^>]*>(.*?<\/\1>)?/;
const REGEXP_HTML_G = /<([\w-]+)[^>]*>(.*?<\/\1>)?/g;

/**
 * script 标签
 */
const REGEXP_SCRIPT = /<script>(.|\n|\r)+?<\/script>/g;

/**
 * 有序列表
 */
const REGEXP_ORDERED_LIST = /(^\d+|\n\d+)\.\s+/g;

/**
 * url
 */
const REGEXP_URL = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/;

/**
 * email
 */
const REGEXP_EMAIL = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/;

/**
 * 汉字
 */
const REGEXP_CHINESE = /[\u4e00-\u9fa5]/g;

/**
 * 单词
 */
const REGEXP_WORDS = /\b\w+\b/g;

/**
 * 匹配英文句子中的句号
 */
const REGEXP_EN_PERIOD = /[a-zA-Z]\./g;

/**
 * 匹配<img>标签,包括闭合与非闭合标签
 */
const REGEXP_ALL_IMG = /<img[^>]*src=.*https?:\/\/[^>]*>/;

/**
 * 使用正则表达式匹配所有img标签
 */
const REGEXP_IMG_SRC = /<img[^>]*\ssrc\s*=\s*\"([^"]*)\"[^>]*>/g;

/**
 * 使用正则表达式过滤掉img后的br标签
 */
const REGEXP_IMG_DEL_BR = /(<img[^>]+>)<br>/g;

/**
 * 使用正则表达式匹配所有img标签
 */
const REGEXP_ALL_IMG_TAGS = /(<img)([^>]*>)/g;

/**
 * 使用正则表达式匹配 <img src的值
 */
const REGEXP_IMG_SRC_URL = /<img[^>]+src="([^"]+)"/;

/**
 * 使用正则表达式优先匹配所有img标签的data-raw-src，其次匹配src的值
 */
const REGEXP_IMG_SRC_URL_PREFER = /<img[^>]+(?:data-raw-src=['"]([^'"]+)['"]|src=['"]([^'"]+)['"])[^>]*>/g;

/**
 * 使用正则表达式过滤掉溯源脚注 ^[xxx]^
 */
const REGEXP_REFERENCE_SUBSCRIPT = /\^[0-9\[\]]*\]\^/g;

/**
 * 使用正则表达式过滤掉中文括号（）、「」、【】、()、半角和全角括号的组合
 */
const REGEXP_BRACKET =  /[(（「【][^()（）「」【】]*[)）」】]/g;

export {
    REGEXP_ALL_IMG,
    REGEXP_ALL_IMG_TAGS,
    REGEXP_BRACKET,
    REGEXP_CHART,
    REGEXP_CHINESE,
    REGEXP_CODE,
    REGEXP_EMAIL,
    REGEXP_EMOJI,
    REGEXP_EN_PERIOD,
    REGEXP_FILE,
    REGEXP_HTML,
    REGEXP_HTML_G,
    REGEXP_IMG,
    REGEXP_IMG_DEL_BR,
    REGEXP_IMG_SRC,
    REGEXP_IMG_SRC_URL,
    REGEXP_IMG_SRC_URL_PREFER,
    REGEXP_IMG_URL,
    REGEXP_MAP_COMPLETE_CONTENT,
    REGEXP_MAP_HEAD_REPLACER,
    REGEXP_MAP_TAIL_REPLACER,
    REGEXP_MAP_UNLESS_CONTENT_HEAD,
    REGEXP_MAP_UNLESS_CONTENT_TAIL,
    REGEXP_ORDERED_LIST,
    REGEXP_PUNCTUATION,
    REGEXP_REFERENCE_SUBSCRIPT,
    REGEXP_SCRIPT,
    REGEXP_TABLE,
    REGEXP_URL,
    REGEXP_WORDS,
    REGEXP_YIYAN_CHART,
};
